import { UPDATE_MAKE_OFFER_MODAL_SHOWN } from '../actions/pdpRespMakeOfferModalActions';

type ActionType = {
    type: 'UPDATE_MAKE_OFFER_MODAL_SHOWN';
    makeOfferModalShown: boolean;
};

type ReducerStateType = {
    makeOfferModalShown: boolean;
};

const initialState = {
    makeOfferModalShown: false,
};

export function pdpRespMakeOfferModalReducer(
    state: ReducerStateType = initialState,
    action: ActionType
): ReducerStateType {
    const { type } = action;

    switch (type) {
        case UPDATE_MAKE_OFFER_MODAL_SHOWN:
            return { ...state, makeOfferModalShown: action.makeOfferModalShown };

        default:
            return state;
    }
}
